import { render } from "./StoreCollectionQianTai.vue?vue&type=template&id=69053a7c&scoped=true"
import script from "./StoreCollectionQianTai.vue?vue&type=script&lang=js"
export * from "./StoreCollectionQianTai.vue?vue&type=script&lang=js"

import "./StoreCollectionQianTai.vue?vue&type=style&index=0&id=69053a7c&lang=scss&scoped=true"

import exportComponent from "F:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69053a7c"]])

export default __exports__